import styled from "styled-components";
import { Container } from "../styled/BaseComponents";
import { theme } from "../styled/theme";

export const NewsWrapper = styled.section`
  margin-top: 2rem;
`;

export const InnerContainer = styled(Container)`
  max-width: 1240px;
`;

export const HeaderRow = styled.div`
  margin-top: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.h2`
  font-size: 1.25rem;
  font-weight: 600;
`;

export const ArrowButtons = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const ArrowButton = styled.button`
  border-radius: 999px;
  border: 1px solid ${theme.colors.border || "#1f2937"};
  background: #020617;
  padding: 0.4rem 0.8rem;
  font-size: 0.8rem;
  cursor: pointer;
  color: ${theme.colors.text || "#f9fafb"};
  box-shadow: 0 0 0 1px rgba(15, 23, 42, 0.9);

  &:hover {
    background: #0f172a;
  }
`;

export const CarouselOuter = styled.div`
  margin-top: 1rem;
  position: relative;
  overflow: hidden;
`;

export const CarouselTrack = styled.div`
  display: flex;
  transition: transform 0.5s ease;
`;

export const CarouselItem = styled.article`
  flex: 0 0 100%;
  padding: 0 0.5rem;
  cursor: pointer;
`;

export const NewsCard = styled.div`
  border-radius: 1.25rem;
  border: 1px solid ${theme.colors.border || "#1f2937"};
  background: rgba(15, 23, 42, 0.9);
  padding: 1rem;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: #38bdf8;
  }
`;

export const NewsDate = styled.div`
  font-size: 0.75rem;
  color: ${theme.colors.muted || "#94a3b8"};
`;

export const NewsTitle = styled.h4`
  margin-top: 0.25rem;
  font-size: 1rem;
  font-weight: 600;
`;

export const NewsExcerpt = styled.p`
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: ${theme.colors.muted || "#94a3b8"};
`;

export const DotsRow = styled.div`
  margin-top: 0.75rem;
  display: flex;
  justify-content: center;
  gap: 0.5rem;
`;

export const Dot = styled.button`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 999px;
  border: none;
  cursor: pointer;
  background: ${(props) => (props.$active ? "#38bdf8" : "#4b5563")};
  opacity: 1;
`;

export const SidebarOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(6px);
  z-index: 100;
`;

export const SidebarPanel = styled.aside`
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  width: 100%;
  max-width: 32rem;
  overflow-y: auto;
  background: #020617;
  border-left: 1px solid #1f2937;
  box-shadow: -12px 0 40px rgba(15, 23, 42, 0.9);
  z-index: 101;
`;

export const SidebarImageWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 14rem;
  overflow: hidden;
`;

export const SidebarImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const SidebarClose = styled.button`
  position: absolute;
  right: 1rem;
  top: 1rem;
  border-radius: 999px;
  border: none;
  padding: 0.35rem 0.75rem;
  background: rgba(0, 0, 0, 0.6);
  color: #f9fafb;
  cursor: pointer;
`;

export const SidebarBody = styled.div`
  padding: 1.5rem;
`;

export const SidebarDate = styled.div`
  font-size: 0.75rem;
  color: ${theme.colors.muted || "#94a3b8"};
`;

export const SidebarTitle = styled.h3`
  margin-top: 0.5rem;
  font-size: 1.5rem;
  font-weight: 700;
`;

export const SidebarContent = styled.p`
  margin-top: 1rem;
  font-size: 0.9rem;
  line-height: 1.6;
  color: ${theme.colors.text || "#e5e7eb"};
`;

export const SidebarActions = styled.div`
  margin-top: 1.5rem;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const SidebarButton = styled.button`
  border-radius: 0.5rem;
  border: 1px solid #1f2937;
  background: #020617;
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  color: ${theme.colors.text || "#f9fafb"};

  &:hover {
    background: #0f172a;
  }
`;

export const SidebarNavRow = styled.div`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SidebarNavButton = styled.button`
  border-radius: 0.5rem;
  border: 1px solid #1f2937;
  background: #020617;
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  color: ${theme.colors.text || "#f9fafb"};

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

